// @todo create a function to generate automatically theses properties
// authorized lets you know if the token is true or not
import { AttributeFromMarketplace } from '@/models';

export default {
  attributes: state => state.attributes.map(a => new AttributeFromMarketplace(a)) || [],
  attribute: state => new AttributeFromMarketplace(state.attribute) || null,
};
